var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'tabs',
    {
      'tabs--small': _vm.small,
    } ]},[_c('div',{staticClass:"tabs--internal"},_vm._l((_vm.tabList),function(item,i){return _c('Button',{key:i,attrs:{"label":item,"is-active":i === _vm.activeTab,"is-fluid":"","is-clear":""},on:{"action":function($event){return _vm.$emit('action', { index: i, label: item })}}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }